import React from 'react';
import { Link } from 'react-router-dom'

export default function GetQuote() {
  return (
    <>
    <section className="getquote-area">
        <div className="container">
            <div className="row">
      
                <div className="col-lg-12">
                    <div className='getquote-box'>
                        <img src="/assets/images/getquote-image.webp" loading="lazy" className="img-responsive" alt="getquote"/>
                        <div className='getquote-detail'>
                            <div>
                                <div  className="quote-title">Partner with Supershine Today!</div>
                                <p>Looking for reliable, hygienic, & professional laundry services? Supershine takes care of your everyday and bulk laundry needs with advanced cleaning, fabric-safe processes, and on-time service you can trust.</p>
                                <Link className="default-btn" to="/contact"><span>Get a quote</span></Link>
                                <Link className='arrow-butn' to="/contact">Work With Us<img src="/assets/images/arrow.webp" loading="lazy" alt="arrow"/></Link>
                            </div>
                        </div>
                    </div> 
                </div> 

            </div>
        </div>
    </section>                
    </>
  )
}
